import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PropertiesSettings } from '../../core/configuration/properties-settings';
import { HelpersService } from '../../core/services/helpers.service';
import { OperationsService } from '../../core/services/operations.service';
import { PagamentoAdapter } from '../components/fascicolo/pagamenti-edit/pagamento-adapter';
import { AltraParte } from '../models/altraparte';
import { BeneficiarioPagamento } from '../models/beneficiario-pagamento';
import { BeneficiarioPagamentoArray } from '../models/beneficiario-pagamento-array';
import { Controparte } from '../models/controparte';
import { SezioneAltrePartiResponse } from '../models/dto/sezione-altre-parti-response';
import { SezioneContropartiResponse } from '../models/dto/sezione-controparti-response';
import { SezioneLegaliResponse } from '../models/dto/sezione-legali-response';
import { LegaleIncaricato } from '../models/legale-incaricato';
import { Pagamento } from '../models/pagamento';
import { SezioneAltreParti } from '../models/sezioni/sezione-altre-parti';
import { SezioneControparti } from '../models/sezioni/sezione-controparti';
import { SezioneLegali } from '../models/sezioni/sezione-legali';
import { Cpa } from '../models/tipologiche/cpa';
import { Iva } from '../models/tipologiche/iva';
import {
  idAltrePartiInTipoBeneficiario,
  idControparteInTipoBeneficiario,
  idLegaleInTipoBeneficiario,
  tipiBeneficiarioPagamentoOptions
} from '../models/tipologiche/mock-tipo-beneficiario';
import { ModalitaPagamento } from '../models/tipologiche/modalita-pagamento';
import { Motivo } from '../models/tipologiche/motivo';
import { TipoGenericoRimovibile } from '../models/tipologiche/tipo-generico-rimovibile';
import { TipoPagamento } from '../models/tipologiche/tipo-pagamento';
import { TipoSommaLiquidata } from '../models/tipologiche/tipo-somma-liquidata';
import { NumericOperationManager } from '../utils/numeric-operation-manager';
import { BaseForm } from './base-Form';

@Component({
    selector: 'div [pagamento-form]',
  templateUrl: 'pagamento-form.html'
})

export abstract class PagamentoForm extends BaseForm {
  readonly PROPERTIES_SETTINGS = PropertiesSettings;
  request: Pagamento;
  pagamentoForm: FormGroup;
  tipoBeneficiario: TipoGenericoRimovibile = null;
  beneficiario: BeneficiarioPagamentoArray = null;
  msgNoBeneficiari: string;

  // options
  ivaOptions: Iva[] = [];
  cpaOptions: Cpa[] = [];
  motiviPagamentoOptions: Motivo[] = [];
  tipiSommaLiquidataOptions: TipoSommaLiquidata[] = [];
  tipiPagamentoOptions: TipoPagamento[] = [];
  modalitaPagamentoOptions: ModalitaPagamento[] = [];
  terzoPignoratoOptions: AltraParte[] = [];

  beneficiarioView: BeneficiarioPagamento;
  beneficiariOptions: BeneficiarioPagamentoArray[] = [] ;
  beneficiariAll: BeneficiarioPagamentoArray[] = [];
  altrePartiAll: AltraParte[] = [];
  contropartiAll: Controparte[] = [];
  legaliAll: LegaleIncaricato[] = [];
  tipiBeneficiariOptions: TipoGenericoRimovibile[] = [] ;
  sections: {altreParti: boolean; controparti: boolean, legali: boolean} = {altreParti: false, controparti: false, legali: false};
  cpaPerc: number;
  ivaPerc: number;

  // toggle html
  visibleToggleAssocia: boolean = false;
  visibleToggleForm: boolean = false;

  // private idTipoPersonaFisica: string = PropertiesSettings.ID_TIPO_PERSONA_FISICA;
  // private idTipoPersonaGiuridica: string = PropertiesSettings.ID_TIPO_PERSONA_GIURIDICA;

  abstract getPagamento(): Pagamento;
  abstract getRequest(request: Pagamento);
  abstract getUrlReadSezioneAltreParti(): string;
  abstract getUrlReadSezioneControparti(): string;
  abstract getUrlReadSezioneLegali(): string;

  @ViewChild('searchItem') searchItemRef!: ElementRef;
  
  constructor(protected operationService: OperationsService,
              private campiForm: FormBuilder,
              private helpers: HelpersService) {
                super();
  }

 initRequest() {
    this.request = new PagamentoAdapter(this.getPagamento()).pagamento;
    if (this.inserimento) {
      this.request.flagRitenutaAcconto = true;
    }
    this.ricalcolaImporti(null, null);
    this.initViewToggle();
  }

  initViewToggle() {
    this.visibleToggleAssocia = false;
    this.visibleToggleForm = true;

    if (this.inserimento) {
      this.visibleToggleAssocia = true;
      this.visibleToggleForm = false;
    }
  }

  createForm() {
    this.initRequest();
    this.pagamentoForm = this.campiForm.group({
      id: [this.request.id],
      tipoBeneficiario: [this.tipoBeneficiario],
      beneficiario: [this.beneficiario],
      dataPagamento: [this.request.dataPagamento, Validators.required],
      tipoPagamento: [this.request.tipoPagamento, Validators.required],
      modalitaPagamento: [this.request.modalitaPagamento],
      motivo: [this.request.motivo, Validators.required],
      tipoSommaLiquidata: [this.request.tipoSommaLiquidata],
      terzoPignorato: [this.request.terzoPignorato],
      numeroAutorizzazione: [this.request.numeroAutorizzazione],
      dataAutorizzazione: [this.request.dataAutorizzazione],
      importo: [this.request.importo, Validators.required],
      cpa: [this.request.cpa],
      iva: [this.request.iva],
      sommaNonSoggettaRitenuta: [this.request.sommaNonSoggettaRitenuta],
      flagRitenutaAcconto: [this.request.flagRitenutaAcconto],
      legaleIncaricato: [this.request.legaleIncaricato],
      controparte: [this.request.controparte],
      altraParte: [this.request.altraParte],
      note: [this.request.note],
      documenti: [this.request.documenti],
    });
  }

  populateSelect() {
    if (this.ivaOptions.length === 0) {
      this.helpers.getIva().subscribe(response => this.ivaOptions = response);
    }
    if (this.cpaOptions.length === 0) {
      this.helpers.getCpa().subscribe(response => this.cpaOptions = response);
    }
    if (this.motiviPagamentoOptions.length === 0) {
      this.helpers.getMotiviPagamento().subscribe(response => this.motiviPagamentoOptions = response);
    }
    if (this.tipiSommaLiquidataOptions.length === 0) {
      this.helpers.getTipiSommaLiquidata().subscribe(response => this.tipiSommaLiquidataOptions = response);
    }
    if (this.tipiPagamentoOptions.length === 0) {
      this.helpers.getTipiPagamento().subscribe(response => this.tipiPagamentoOptions = response);
    }
    if (this.modalitaPagamentoOptions.length === 0) {
      this.helpers.getModalitaPagamento().subscribe(response => this.modalitaPagamentoOptions = response);
    }
    if (this.tipiBeneficiariOptions.length === 0) {
      let tipiBeneficiariOptionsAppoggio:  TipoGenericoRimovibile[] = <TipoGenericoRimovibile[]> JSON.parse(JSON.stringify(tipiBeneficiarioPagamentoOptions));
      for (let tipoBeneficiario of tipiBeneficiariOptionsAppoggio) {
        tipoBeneficiario.rimosso = this.checkTipoBeneficiarioPresente(tipoBeneficiario.id);
      }
      this.tipiBeneficiariOptions = tipiBeneficiariOptionsAppoggio;
    }
    if (this.request && this.request.controparte) {
      for (let tipo of tipiBeneficiarioPagamentoOptions) {
        if (tipo.id === idControparteInTipoBeneficiario) {
          this.tipoBeneficiario = tipo;
        }
      }
      this.beneficiariOptions = this.beneficiariAll.filter(beneficiarioArray => { return beneficiarioArray.beneficiarioPagamento.tipoBeneficiarioPagamento.id === idControparteInTipoBeneficiario; });
      for (let beneficiario of this.beneficiariOptions) {
        if (beneficiario.beneficiarioPagamento.persona.id === this.request.controparte.parte.id) {
          this.beneficiario = beneficiario;
        }
      }
    }
    if (this.request && this.request.legaleIncaricato) {
      for (let tipo of tipiBeneficiarioPagamentoOptions) {
        if (tipo.id === idLegaleInTipoBeneficiario) {
          this.tipoBeneficiario = tipo;
        }
      }
      this.beneficiariOptions = this.beneficiariAll.filter(beneficiario => { return beneficiario.beneficiarioPagamento.tipoBeneficiarioPagamento.id === idLegaleInTipoBeneficiario; });
      for (let beneficiario of this.beneficiariOptions) {
        if (beneficiario.beneficiarioPagamento.persona.id === this.request.legaleIncaricato.legale.id) {
          this.beneficiario = beneficiario;
        }
      }
    }
    if (this.request && this.request.altraParte) {
      for (let tipo of tipiBeneficiarioPagamentoOptions) {
        if (tipo.id === idAltrePartiInTipoBeneficiario) {
          this.tipoBeneficiario = tipo;
        }
      }
      this.beneficiariOptions = this.beneficiariAll.filter(beneficiario => { return beneficiario.beneficiarioPagamento.tipoBeneficiarioPagamento.id === idAltrePartiInTipoBeneficiario; });
      for (let beneficiario of this.beneficiariOptions) {
        if (beneficiario.beneficiarioPagamento.persona.id === this.request.altraParte.parte.id) {
          this.beneficiario = beneficiario;
        }
      }
    }
  }

  public setTextEmpty() {
    this.searchItemRef.nativeElement.value = '';
  }

  checkTipoBeneficiarioPresente(idTipoBeneficiario: string): boolean {
    if (this.beneficiariAll.length > 0) {
      return this.beneficiariAll.filter(beneficiario => { return beneficiario.beneficiarioPagamento.tipoBeneficiarioPagamento.id === idTipoBeneficiario; }).length === 0;
    }
    return true;
  }
  save() {
    this.getRequest(this.request);
  }

  private getBeneficiarioPagamentoArray(beneficiarioNew: BeneficiarioPagamento): BeneficiarioPagamentoArray {
    let beneficiarioNewArray = new BeneficiarioPagamentoArray();
    beneficiarioNewArray.beneficiarioPagamento = beneficiarioNew;
    beneficiarioNewArray.id = beneficiarioNew.persona.id;
    return beneficiarioNewArray;
  }

  readSezioneAltreParti(idSezioneAltreParti: string) {
    if (idSezioneAltreParti) {
      this.operationService.readSezione(this.getUrlReadSezioneAltreParti(), idSezioneAltreParti)
        .subscribe(response => this.readSezioneAltrePartiResponse((<SezioneAltrePartiResponse>response).sezione));
    } else {
      this.sections.altreParti = true;
    }
  }

  readSezioneAltrePartiResponse(sezioneAltreParti: SezioneAltreParti) {
    this.altrePartiAll = sezioneAltreParti.altreParti;
    this.altrePartiAll = this.altrePartiAll.filter(altraParte => { return altraParte.ritirato === false; });
    //this.terzoPignoratoOptions = this.altrePartiAll.filter(altraParte => { return altraParte.categoriaAltraParte.label === PropertiesSettings.LABEL_TERZO_PIGNORATO; }); // id 6 per terzo pignorato


    for (let altraParte of this.altrePartiAll) {
        let beneficiarioNew: BeneficiarioPagamento = new BeneficiarioPagamento();
        beneficiarioNew.idParent = altraParte.id;
        beneficiarioNew.tipoBeneficiarioPagamento = tipiBeneficiarioPagamentoOptions.filter(tB => { return tB.id === idAltrePartiInTipoBeneficiario; })[0];
        beneficiarioNew.persona = altraParte.parte;
        //beneficiarioNew.categoria = altraParte.categoriaAltraParte.label;
        let beneficiarioNewArray = this.getBeneficiarioPagamentoArray(beneficiarioNew);
        this.beneficiariAll.push(beneficiarioNewArray);
    }
    this.sections.altreParti = true;
    if (this.sections.altreParti && this.sections.controparti && this.sections.legali) {
      this.populateSelect();
    }
  }

  readSezioneControparti(idSezioneControparti: string) {
    if (idSezioneControparti) {
      this.operationService.readSezione(this.getUrlReadSezioneControparti(), idSezioneControparti)
        .subscribe(response => this.readSezioneContropartiResponse((<SezioneContropartiResponse>response).sezione));
    } else {
      this.sections.controparti = true;
    }
  }

  readSezioneContropartiResponse(sezioneControparti: SezioneControparti) {
    this.contropartiAll = sezioneControparti.controparti;
    this.contropartiAll = this.contropartiAll.filter(controparte => { return controparte.ritirato === false; });
    for (let controparte of this.contropartiAll) {
        let beneficiarioNew = new BeneficiarioPagamento();
        beneficiarioNew.idParent = controparte.id;
        beneficiarioNew.tipoBeneficiarioPagamento = tipiBeneficiarioPagamentoOptions.filter(tB => { return tB.id === idControparteInTipoBeneficiario; })[0];
        beneficiarioNew.persona = controparte.parte;
        beneficiarioNew.categoria = controparte.primario ? 'CONTROPARTE PRIMARIA' : 'CONTROPARTE';
        let beneficiarioNewArray = this.getBeneficiarioPagamentoArray(beneficiarioNew);
        this.beneficiariAll.push(beneficiarioNewArray);
    }
    this.sections.controparti = true;
    if (this.sections.altreParti && this.sections.controparti && this.sections.legali) {
      this.populateSelect();
    }
  }

  readSezioneLegali(idSezioneLegali: string) {
    if (idSezioneLegali) {
      this.operationService.readSezione(this.getUrlReadSezioneLegali(), idSezioneLegali)
        .subscribe(response => this.readSezioneLegaliResponse((<SezioneLegaliResponse>response).sezione));
    } else {
      this.sections.legali = true;
    }
  }

  readSezioneLegaliResponse(sezioneLegali: SezioneLegali) {
    this.legaliAll = sezioneLegali.legaliIncaricati;
    this.legaliAll = this.legaliAll.filter(legaleIncaricato => { return legaleIncaricato.revocato === false; });
    for (let legale of this.legaliAll) {
        let beneficiarioNew = new BeneficiarioPagamento();
        beneficiarioNew.idParent = legale.id;
        beneficiarioNew.tipoBeneficiarioPagamento = tipiBeneficiarioPagamentoOptions.filter(tB => { return tB.id === idLegaleInTipoBeneficiario; })[0];
        beneficiarioNew.persona = legale.legale;
        beneficiarioNew.categoria = legale.categoriaLegaleIncaricato.label;
        let beneficiarioNewArray = this.getBeneficiarioPagamentoArray(beneficiarioNew);
        this.beneficiariAll.push(beneficiarioNewArray);
    }
    this.sections.legali = true;
    if (this.sections.altreParti && this.sections.controparti && this.sections.legali) {
      this.populateSelect();
    }
    this.msgNoBeneficiari = 'Non esistono beneficiari da associare';
  }

  populateBeneficiari(tipo: TipoGenericoRimovibile) {
    this.tipoBeneficiario = tipo;
    this.beneficiario = null;
    this.request.controparte = null;
    this.request.altraParte = null;
    this.request.legaleIncaricato = null;
    if (tipo && tipo.id && this.beneficiariAll.length > 0) {
      this.beneficiariOptions = this.beneficiariAll.filter(beneficiario => { return beneficiario.beneficiarioPagamento.tipoBeneficiarioPagamento.id === tipo.id; });
    } else {
      this.beneficiariOptions = [];
    }
  }

  goToAssocia() {
    this.createForm();
    this.visibleToggleAssocia = true;
    this.visibleToggleForm = false;
  }

  getTerzoPignorato(obj: any) {
    if (obj.id) {
      this.request.terzoPignorato =  this.terzoPignoratoOptions.filter(altraParte => { return altraParte.id === obj.id; })[0];
    }
  }

  setBeneficiarioFromEvent(bpa: BeneficiarioPagamentoArray) {
    this.beneficiario = bpa;
    if (this.beneficiario) {
      this.setBeneficiario(bpa);
    } else {
      this.request.controparte = null;
      this.request.altraParte = null;
      this.request.legaleIncaricato = null;
    }
  }

  setBeneficiario(beneficiarioArray: BeneficiarioPagamentoArray) {
    let beneficiario: BeneficiarioPagamento = beneficiarioArray.beneficiarioPagamento;
    this.request.controparte = null;
    this.request.altraParte = null;
    this.request.legaleIncaricato = null;
    if (beneficiario.tipoBeneficiarioPagamento.id === idControparteInTipoBeneficiario) {
      this.request.controparte =  this.contropartiAll.filter(controparte => { return controparte.id === beneficiario.idParent; })[0];
    }
    if (beneficiario.tipoBeneficiarioPagamento.id === idLegaleInTipoBeneficiario) {
      this.request.legaleIncaricato =  this.legaliAll.filter(legaleIncaricato => { return legaleIncaricato.id === beneficiario.idParent; })[0];
    }
    if (beneficiario.tipoBeneficiarioPagamento.id === idAltrePartiInTipoBeneficiario) {
      this.request.altraParte =  this.altrePartiAll.filter(altraParte => { return altraParte.id === beneficiario.idParent; })[0];
    }
    this.beneficiarioView = beneficiario;
    this.visibleToggleAssocia = false;
    this.visibleToggleForm = true;
  }

  ricalcolaImporti(event: any, tipoPerc: string) {
    let perc = 0;
    if (event && event.target && event.target.selectedIndex) {
      let percId = event.target.selectedIndex;
      if (event.target.options[percId] && event.target.options[percId].label) {
        perc = event.target.options[percId].label;
      }else {
        perc = 0;
      }
      switch (tipoPerc) {
       case 'cpa' :
          this.cpaPerc = perc;
          break;
       case 'iva' :
          this.ivaPerc = perc;
          break;
      }
    } else {
        this.cpaPerc = this.request.cpa ? this.request.cpa.valore  : 0;
        this.ivaPerc = this.request.iva ? this.request.iva.valore  : 0;
    }
  }

  getSum(...args: string[]) {
    return NumericOperationManager.getSum(args);
  }

  getDiff(a: string, b: string) {
    return NumericOperationManager.getDiff(a, b);
  }

  reset() {
    this.tipoBeneficiario = null;
    this.beneficiario = null;
    this.beneficiariOptions = [];
    this.createForm();
    this.populateSelect();
  }
}
